import axios from "axios";
import {API_BASE_URL, API_URLS} from "constants/api";

export const useLocalization = () => {
  const getLocalization = async (locale: string) => {
    const result = await axios.get(`${API_BASE_URL}${API_URLS.Localization.replace('{locale}', locale)}`);
  };

  return { getLocalization };
};
